import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IHostColorSchemeService = ( createDecorator('hostColorSchemeService'));
export { IHostColorSchemeService };
